import Layout from 'lib/components/Layout'

import HeroSection from 'pages/Studio/Home/sections/Hero'
import GamesSection from 'pages/Studio/Home/sections/Games'

import { STUDIO_NAVIGATION } from './navigation'

const StudioHome = () => (
  <Layout navigation={STUDIO_NAVIGATION} homeHref="/">
    <HeroSection />

    <GamesSection />
  </Layout>
)

export default StudioHome
